<template>
  <Slide anchor="portfolio" title="Портфолио" linkable>
    <PortfolioProject
      v-for="(project, name) in portfolio"
      :key="name"
      :project="project"
      :name="name"
    />
  </Slide>
</template>

<script>
  import Slide from './Slide';
  import PortfolioProject from './PortfolioProject';

  export default {
    name: 'Portfolio',
    components: { PortfolioProject, Slide },

    data() {
      return {
        portfolio: {
          'basal-group': {
            title: 'BASAL GROUP',
            description: 'Сайт строительного холдинга',
            developers: [
              {
                role: 'Заказчик',
                name: 'ООО Базал Групп',
              },
              {
                role: 'Разработчик',
                name: 'flex-studio',
              },
              {
                role: 'Дизайн',
                name: 'Предоставлен заказчиком',
              },
            ],
            imageCount: 3,
            versions: [
              'desktop',
              'tablet',
              'mobile',
            ],
          },
          'na-urovne': {
            title: 'На-уровне',
            description: 'Ремонт квартир и офисов',
            developers: [
              {
                role: 'Заказчик',
                name: 'ИП Зиннатуллин З.З.',
              },
              {
                role: 'Разработчик',
                name: 'flex-studio',
              },
              {
                role: 'Дизайн',
                name: 'Предоставлен заказчиком',
              },
            ],
            imageCount: 1,
            versions: [
              'desktop',
              'tablet',
              'mobile',
            ],
          },
          'techstroi': {
            title: 'Техстрой',
            description: 'Крупный игрок рынка буровых услуг',
            developers: [
              {
                role: 'Заказчик',
                name: 'ООО "Техстрой"',
              },
              {
                role: 'Разработчик',
                name: 'flex-studio',
              },
              {
                role: 'Дизайн',
                name: 'Предоставлен заказчиком',
              },
            ],
            imageCount: 3,
            versions: [
              'desktop',
              'tablet',
            ],
          },
          'sma': {
            title: 'ООО «СМА»',
            description: 'Строительство, ремонт и электромонтажные работы',
            developers: [
              {
                role: 'Заказчик',
                name: 'ООО "Спецмонтажавтоматика"',
              },
              {
                role: 'Разработчик',
                name: 'flex-studio',
              },
              {
                role: 'Дизайн',
                name: 'Предоставлен заказчиком',
              },
            ],
            imageCount: 2,
            versions: [
              'desktop',
              'tablet',
              'mobile',
            ],
          },
          'tortuga': {
            title: 'Бар «Tortuga»',
            description: 'Пивной бар',
            developers: [
              {
                role: 'Заказчик',
                name: 'ИП Куртеев Д.А.',
              },
              {
                role: 'Разработчик',
                name: 'flex-studio',
              },
              {
                role: 'Дизайн',
                name: 'Предоставлен заказчиком',
              },
            ],
            imageCount: 2,
            versions: [
              'desktop',
              'tablet',
            ],
          },
        },
      };
    },
  };
</script>

<style lang="less" scoped>
  //
</style>

<style lang="less">
  @import (reference) '../shared.less';

  #portfolio {
    .content {
      @media @vertical {
        flex-wrap: wrap;
      }

      @media @mobile-vertical {
        flex-direction: column;
        align-items: center;
      }
    }
  }
</style>
